import Vue from 'vue'

export default ({cfdi,listSinisters}) => {

  const example={cfdi:cfdi,list_sinister:listSinisters}

  return Vue.$http.post('taxreceipt/taxreceiptsinister/', example)
    .then((response) => {
      let data = response.data
      return data
    })
}


// WEBPACK FOOTER //
// ./src/services/taxReceipt/createTaxReceipt.js